import Link from "next/link";
import { useRouter } from "next/router";
import {
  Button,
  NoMatchingResultIllustration,
  AccessDeniedIllustration,
  cn,
} from "ui";
import type { ErrorResponse } from "../hooks/useMoneyHashQuery";

export interface ErrorPageProps extends React.HTMLAttributes<HTMLDivElement> {
  error: ErrorResponse;
}

export function ErrorPage({ error, className, ...props }: ErrorPageProps) {
  const statusCode = error?.response?.data?.status?.code;
  const isPermissionError = statusCode === 403;
  const isNotFoundError = statusCode === 404;
  const router = useRouter();

  return (
    <div
      className={cn(
        "mx-auto mt-20 flex max-w-md flex-col items-center space-y-4 text-center",
        className
      )}
      {...props}
    >
      {isPermissionError ? (
        <AccessDeniedIllustration className="h-[150px] w-[150px]" />
      ) : (
        <NoMatchingResultIllustration className="h-[150px] w-[150px]" />
      )}
      <h2 className="text-foundations-boldest text-lg font-bold">
        {isNotFoundError ? (
          <>Error 404</>
        ) : isPermissionError ? (
          <>Access Denied!</>
        ) : (
          <>Error</>
        )}
      </h2>
      <p className="text-foundations-subtle text-sm">
        {isNotFoundError ? (
          <>
            Page not found or moved somewhere else, please try again later or go
            home.
          </>
        ) : isPermissionError ? (
          <>
            You don&apos;t have permission to access this page, If you feel this
            is a mistake contact your admin.
          </>
        ) : (
          <>
            It looks like there&apos;s nothing here yet. We are waiting for
            initial data. Please try again later.
          </>
        )}
      </p>
      {router.pathname !== "/" && (
        <Button asChild size="xs">
          <Link href="/">Go home</Link>
        </Button>
      )}
    </div>
  );
}
